import { IntlShape } from 'react-intl'
import { UserData } from '@src/types'
import { transformUserData } from './transformUserData'

interface Props {
  userData: UserData
  intl: IntlShape
}

export const createInitialValueWithUserData = (props: Props, initialValues) => {
  const {
    userData,
    intl: { formatMessage }
  } = props

  return {
    ...initialValues(formatMessage),
    ...transformUserData(userData)
  }
}
